


import {h} from 'preact';
import LinksToSocialNetworks from "../../components/LinksToSocialNetworks/LinksToSocialNetworks";
import CasesGrid from "../../components/CasesGrid/CasesGrid";
import FeedbackSlider from "../../components/FeedbackSlider/FeedbackSlider";
import styles from "./style.scss"
import ReturnBack from "./ReturnBack";

const Success = () => {
    return (
        <main id="main-container" className={styles.wrapper} main-attr>
            <ReturnBack></ReturnBack>
            <h1>Отчет о стипендиях и мерах поддержки обучающихся ООО «ИТК»</h1>
            <p>Стипендии и иные виды материальной поддержки обучающихся в ООО «ИТК» не предусмотрены.</p>
            <p>Общежития и интернат: отсутствуют.</p>
            <p>Информация о мерах социальной поддержки: меры социальной поддержки для обучающихся не предусмотрены.</p>
            <p>Информация о трудоустройстве выпускников: трудоустройство не предоставляется.</p>

        </main>
    );
};

export default Success;
